import { Box, Button, IconButton, Stack, Text } from "@chakra-ui/react";
import { useState } from "react";
import { APPICONS } from "../Icons";
import { CellProps, TWSysEntity, useWSysPage, WSysPage, WSysVert } from "@coimbra-its/websys-ux-core";

export interface WSysTableSettingsProps<TRow extends TWSysEntity> {
    reset?: {
        title: string;
        orderBy: string;
    }
    cells: Array<CellProps<TRow>>;
    orderBy: string;
    orderByChanged: (field: string) => void;
}

export function WSysTableSettings<TRow extends TWSysEntity>({ ...rest }: WSysTableSettingsProps<TRow>) {

    const [isOpen, setIsOpen] = useState(false);

    return <>
        {/*<Box position='absolute' right='13px' top={0} zIndex={1}>*/}
        <IconButton icon={<APPICONS.Settings />} aria-label="table settings" onClick={() => setIsOpen(true)} size='sm' />
        {isOpen && <WSysTableSettingsPage onClosed={() => setIsOpen(false)} {...rest} />}
    </>;
}

export interface WSysTableSettingsPageProps<TRow extends TWSysEntity> extends WSysTableSettingsProps<TRow> {
    onClosed: () => void;
}

export function WSysTableSettingsPage<TRow extends TWSysEntity>({ onClosed, cells, orderByChanged, orderBy, reset, ...rest }: WSysTableSettingsPageProps<TRow>) {
    const page = useWSysPage({ title: 'Tábla beállítások', maxCols: 2, onClosed, });
    const orderByClick = (field: string) => {
        orderByChanged(field);
        onClosed();
    }

    return <WSysPage page={page} >
        <WSysVert mode="rest" p={2}>
            <Stack gap={1}>
                {cells.filter(c => c.field).map((cell, cix) => <Box key={cix} display='flex' flexDir='row' flex={1}
                    borderBottom='1px solid #8883'
                >
                    <Text p={2}>
                        {cell.title}
                    </Text>
                    <Box display='flex' flexDir='row' ml='auto'>
                        <Button onClick={() => orderByClick(cell.field!)} {...orderBy === cell.field && { colorScheme: 'blue' }} size='sm' >&darr;&nbsp;Növekvő</Button>
                        <Button onClick={() => orderByClick('-' + cell.field!)} {...orderBy === '-' + cell.field && { colorScheme: 'blue' }} size='sm'>&uarr;&nbsp;Csökkenő</Button>
                    </Box>
                </Box>)}
                {reset && <Box p={2} display='flex' flexDir='row' alignItems='center' justifyContent='flex-end' >
                    <Button onClick={() => orderByClick(reset.orderBy)} {...orderBy === reset.orderBy && { colorScheme: 'blue' }} size='sm'  >{reset.title}</Button>
                </Box>}
            </Stack>
        </WSysVert>
    </WSysPage>;

}
